import type { Database } from "@/lib/database.types";

export type RecipeLogRow = Database["public"]["Tables"]["recipe_logs"]["Row"];

/** A single cook-log entry: one date a recipe was made, plus an optional note. */
export interface RecipeLog {
    readonly id: number;
    readonly recipeId: number;
    readonly madeOn: string; // YYYY-MM-DD (date only, no time)
    readonly note: string;
    readonly createdAt: string;
}

export function mapDatabaseLogToRecipeLog(row: RecipeLogRow): RecipeLog {
    return {
        id: row.id,
        recipeId: row.recipe_id,
        madeOn: row.made_on,
        note: row.note ?? "",
        createdAt: row.created_at
    };
}
